
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_368_168853)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#748190"}},[_c('path',{attrs:{"d":"M4.186 6.778c-.193-.322-.724-.628-1.336-.628-.789 0-1.167.33-1.167.749 0 .49.58.628 1.255.708 1.176.145 2.27.451 2.27 1.795 0 1.256-1.11 1.795-2.366 1.795-1.151 0-2.037-.354-2.455-1.384l.885-.459c.25.62.902.893 1.586.893.668 0 1.296-.233 1.296-.845 0-.531-.556-.748-1.304-.829C1.699 8.436.636 8.13.636 6.867c0-1.16 1.143-1.634 2.182-1.642.877 0 1.787.25 2.213 1.119l-.845.434zM11.551 8.163c.008.644-.16 1.312-.523 1.835l.668.66-.748.749-.685-.676c-.426.273-.966.418-1.601.418-2.005 0-2.89-1.457-2.898-2.922-.008-1.473.917-2.946 2.898-2.946 1.98 0 2.865 1.433 2.89 2.882zm-4.74.089c.015.925.627 1.915 1.85 1.915 1.272 0 1.884-1.07 1.844-2.036-.04-.91-.515-1.892-1.843-1.892-1.329 0-1.868 1.063-1.852 2.013zM13.386 5.418v4.652h2.898v.983h-3.96V5.418h1.062z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_368_168853"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.06)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    